<artboard-presentation
  id="artboard"
  class="artboard-presentation"
  style="transform-origin: 0% 0%; transition: all 0.4s"
  (mousedown)="placeholderService.clearPlaceholder()"
  [style.width]="
    editorService.presentation.width +
    this.widthIncrement +
    editorService.presentation.widthUnits
  "
  [style.height]="
    editorService.presentation.height +
    this.heightIncrement +
    editorService.presentation.heightUnits
  "
  [style.transform]="'scale(' + artboardService.zoomLevel + ')'"
>
</artboard-presentation>
